import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "create__trade__modal__setting" }
const _hoisted_2 = { class: "create__trade__modal__setting__row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, " You're almost finished! Just set up your workstation to upload the Trade Passport details. ", -1)
const _hoisted_4 = { class: "create__trade__modal__setting__left" }
const _hoisted_5 = { class: "bottom-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_commonDialog = _resolveComponent("commonDialog")!

  return (_openBlock(), _createBlock(_component_commonDialog, {
    HeaderTittle: "Create a Trade Workstation",
    onClickBackButton: $setup.onClickBackButton,
    class: "create__trade__modal__box",
    "max-width": "100%",
    width: "570px"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_btn, {
                class: "button button-orange",
                onClick: $setup.onClickCreateWS
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Create a Trade Workstation ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClickBackButton"]))
}